import { getPriceString } from './getPriceString';

// Etichetta e dettaglio di un'opzione di prezzo tipizzata del wizard (perPerson/perHour/flat).
// Le opzioni legacy senza `type` (o flat migrate con `people`) ricadono sul formato storico
// "X CHF / N persone" così le attività esistenti restano leggibili.
// Ritorna { label, detail }: detail è il testo secondario (es. "Massimo 4 partecipanti") o null.
export const getBundleLabel = (option, t) => {
    const type = option.type || 'flat';
    if (type === 'perPerson') {
        return { label: t('BookingWizard.option.perPerson', { value: option.value }), detail: null };
    }
    if (type === 'perHour') {
        return { label: t('BookingWizard.option.perHour', { value: option.value }), detail: null };
    }
    if (option.maxQty) {
        return {
            label: t('BookingWizard.option.flat', { value: option.value }),
            detail: t('BookingWizard.option.flatMaxParticipants', { max: option.maxQty })
        };
    }
    if (option.people) {
        return { label: getPriceString(option.value, option.people), detail: null };
    }
    return { label: t('BookingWizard.option.flat', { value: option.value }), detail: null };
};
